<template>
  <div>
    <!-- 数据概览 -->
    <div class="data-overview">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card shadow="hover">
            <div class="card-content">
              <i class="el-icon-box card-icon"></i>
              <div>
                <div class="card-title">今日订单数量</div>
                <div class="card-value">
                  {{ currentDataStatistics.orderQuantity }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <div class="card-content">
              <i class="el-icon-shopping-cart-full card-icon"></i>
              <div>
                <div class="card-title">今日退单数量</div>
                <div class="card-value">
                  {{ currentDataStatistics.returnOrderQuantity }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <div class="card-content">
              <i class="el-icon-warning-outline card-icon"></i>
              <div>
                <div class="card-title">销售总额</div>
                <div class="card-value">
                  {{ currentDataStatistics.totalOrderAmount }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card shadow="hover">
            <div class="card-content">
              <i class="el-icon-office-building card-icon"></i>
              <div>
                <div class="card-title">销售利润</div>
                <div class="card-value">
                  {{ currentDataStatistics.totalProfit }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 销售趋势图表 -->
    <el-card class="chart-card">
      <div slot="header" class="chart-title">
        <span>近一月销售趋势</span>
      </div>

      <div>
        <el-card>
          <!-- 折线图组件 -->
          <line-chart
            ref="lineChartRef"
            :api-data="chartData"
            :y-axis-name="'金额'"
            :loading="loading"
          />

          <!-- 统计数据展示 -->
          <el-row :gutter="20" style="margin-top: 5px">
            <el-col :span="6">
              <el-statistic title="数据总量" :value="totalValue" />
            </el-col>
            <el-col :span="6">
              <el-statistic
                title="平均值"
                :value="averageValue"
                :precision="2"
              />
            </el-col>
            <el-col :span="6">
              <el-statistic title="最大值" :value="maxValue" />
            </el-col>
            <el-col :span="6">
              <el-statistic title="最小值" :value="minValue" />
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
import LineChart from "./LineChart.vue";
import axios from "axios";

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      chartData: {},
      loading: false,
      totalValue: 0,
      averageValue: 0,
      maxValue: 0,
      minValue: 0,
      currentDataStatistics: {
        orderQuantity: 0,
        returnOrderQuantity: 0,
        totalOrderAmount: 0,
        totalProfit: 0,
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true;
      try {
        await this.getCurrentData();
        await this.getChartData();

        // 计算统计数据
        this.calculateStats();
      } catch (error) {
        this.$message.error("数据加载失败: " + error.message);
        console.error("Error fetching chart data:", error);
      } finally {
        this.loading = false;
      }
    },

    async getCurrentData() {
      try {
        const response = await axios.get(
          "/api/DataStatistics/getCurrentDayStatisticsInfo"
        );

        this.currentDataStatistics = response.data.result;
      } catch (error) {
        this.error = true;
        this.errorMessage = error.message || "未知错误";
        console.error("数据加载失败:", error);
      }
    },

    async getChartData() {
      try {
        const response = await axios.get(
          "/api/DataStatistics/getPastMonthStatisticsInfo"
        );

        this.chartData = response.data.result;
      } catch (error) {
        this.error = true;
        this.errorMessage = error.message || "未知错误";
        console.error("数据加载失败:", error);
      }
    },

    // 计算统计数据
    calculateStats() {
      const values = Object.values(this.chartData);
      if (values.length === 0) return;

      this.totalValue = values.reduce((sum, val) => sum + val, 0);
      this.averageValue = this.totalValue / values.length;
      this.maxValue = Math.max(...values);
      this.minValue = Math.min(...values);
    },
  },
};
</script>

<style scoped>
.data-overview {
  margin-bottom: 20px;
}

.card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-icon {
  font-size: 40px;
  margin-right: 15px;
  color: #409eff;
}

.card-title {
  color: #909399;
  margin-bottom: 5px;
}

.card-value {
  font-size: 24px;
  font-weight: bold;
}

.chart-card {
  margin-bottom: 20px;
}

.chart-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-statistic {
  text-align: center;
}
</style>